export default "<app-nav-menu></app-nav-menu>\r\n"